import { call } from "../helpers/axiosInterceptor";

const getAttendanceByDate = async (batchId: string, date: string) => {
  try {
    const { data } = await call.get(`attendence/${batchId}/${date}`, {  // ✅ Ensure courseId is included
      headers: { Authorization: "Bearer " + localStorage.getItem("refToken") },
    });
    return data;
  } catch (e) {
    
  }
};

const saveAttendance = async (payload: { batch: string; date: string; student: any[] }) => {
  try {
    
    const { data } = await call.post("attendence/save", payload, {
      headers: { Authorization: "Bearer " + localStorage.getItem("refToken") },
    });
    return data;
  } catch (e) {
    
  }
};

export { getAttendanceByDate, saveAttendance };
